import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import {
  getCampaignByStoreId,
  getCouponsForUser,
  getMultipleStoreDiscountAvailable,
  getOrganizationLessons,
  getOrganizationStores,
  getProductsWithCategories,
  getRatingBreakdownsForProducts,
  getStoreDiscountAvailable,
  getTaxonomyNames,
} from '../js/common/api';
import { fetchCampaignAssetData } from '../campaign/campaignAsset/campaignAssetReducer';
import { fetchStoreCampaigns } from '../product/productDetailsActions';

export const fetchCampaignForStore = createAsyncThunk(
  'productCategory/fetchCampaignForStore',
  (storeId) => getCampaignByStoreId(storeId),
);

export const fetchMultipleStoreDiscountAvailable = createAsyncThunk(
  'productCategory/fetchMultipleStoreDiscountAvailable',
  ({ storeIds, ignoreCache = false }) => getMultipleStoreDiscountAvailable(storeIds, ignoreCache),
);

export const fetchOrganizationCoupons = createAsyncThunk(
  'productCategory/fetchOrganizationCoupons',
  ({ orgId }) => getCouponsForUser({ orgStoreIds: { [orgId]: null } }),
);

export const fetchOrganizationLessons = createAsyncThunk(
  'productCategory/fetchOrganizationLessons',
  ({ orgId, searchOptions = {} }) => getOrganizationLessons(orgId, searchOptions),
);

export const fetchOrganizationStores = createAsyncThunk(
  'productCategory/fetchOrganizationStores',
  ({ orgId, ignoreCache = false }) => getOrganizationStores(orgId, ignoreCache),
);

export const fetchProductsWithCategories = createAsyncThunk(
  'productCategory/fetchProductsWithCategories',
  ({ searchConfiguration, searchTerm }) => getProductsWithCategories(searchConfiguration, searchTerm),
);

export const fetchRatingBreakdowns = createAsyncThunk(
  'productCategory/fetchRatingBreakdowns',
  ({ orgId, productCodes = [] }) => getRatingBreakdownsForProducts(orgId, productCodes),
);

export const fetchStoreDiscountAvailable = createAsyncThunk(
  'productCategory/fetchStoreDiscountAvailable',
  ({ storeId, ignoreCache = false }) => getStoreDiscountAvailable(storeId, ignoreCache),
);

export const fetchTaxonomyNames = createAsyncThunk(
  'productCategory/fetchTaxonomyNames',
  (taxonomyIds) => getTaxonomyNames(taxonomyIds),
);

export const setTaxonomyNames = createAction('productCategory/setTaxonomyNames');

export { fetchCampaignAssetData };

const ProductCategoryActions = (dispatch) => ({
  fetchCampaignAssetData: (campaignId) => {
    dispatch(fetchCampaignAssetData(campaignId));
  },
  fetchCampaignsForStores: (storeIds) => {
    dispatch(fetchStoreCampaigns(storeIds));
  },
  fetchCampaignForStore: (storeId) => {
    dispatch(fetchCampaignForStore(storeId));
  },
  fetchOrganizationCoupons: ({ orgId }) => {
    dispatch(fetchOrganizationCoupons({ orgId }));
  },
  fetchOrganizationLessons: (orgId, searchOptions) => {
    dispatch(fetchOrganizationLessons({ orgId, searchOptions }));
  },
  fetchOrganizationStores: (orgId) => {
    dispatch(fetchOrganizationStores({ orgId, ignoreCache: true }));
  },
  fetchProductsWithCategories: (searchConfiguration, searchTerm) => {
    dispatch(fetchProductsWithCategories({ searchConfiguration, searchTerm }));
  },
  fetchMultipleStoreDiscountAvailable: (storeIds) => {
    dispatch(fetchMultipleStoreDiscountAvailable({ storeIds, ignoreCache: true }));
  },
  fetchRatingBreakdowns: (orgId, productCodes = []) => {
    dispatch(fetchRatingBreakdowns({ orgId, productCodes }));
  },
  fetchStoreDiscountAvailable: (storeId) => {
    dispatch(fetchStoreDiscountAvailable({ storeId, ignoreCache: true }));
  },
  fetchTaxonomyNames: (taxonomyIds) => {
    dispatch(fetchTaxonomyNames(taxonomyIds));
  },
  setTaxonomyNames: (taxonomyNames) => {
    dispatch(setTaxonomyNames(taxonomyNames));
  },
});

export default ProductCategoryActions;
